import styled from "styled-components";

const FlatButton = styled.button`
  background-color: ${props => props.theme.backgroundDark};
  color: ${props => props.theme.textLight};
`;

export default FlatButton;
